import { inventoryItemIdFormat } from "@redotech/redo-inventory-id";
import { consolidationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { ConsolidationInventoryItemSchema } from "./consolidation-inventory-item";

const ConsolidationItemSchema_ = ConsolidationInventoryItemSchema.extend({
  packedQuantity: z.number().int(),
  registeredQuantity: z.number().int(),
});

export const ConsolidationItemSchema: z.ZodType<ConsolidationItem> =
  ConsolidationItemSchema_;
export interface ConsolidationItem extends z.infer<
  typeof ConsolidationItemSchema_
> {}

export const listConsolidationItems = {
  name: "listConsolidationItems" as const,
  input: z.object({
    consolidationId: consolidationIdFormat.schema,
    cursor: inventoryItemIdFormat.schema.optional(),
    pageSize: z.number().int().min(1).max(500).default(100),
  }),
  output: z.object({
    items: z.array(ConsolidationItemSchema),
    nextCursor: inventoryItemIdFormat.schema.nullable(),
  }),
};
